<div
    class="{{ trackingClass() }}"
    [ngClass]="{
        'casino-backgroungImage-Clr': hasNoBackgroundImages(),
    }"
    [ngStyle]="{ background: subCategoryInfo()?.sitecoreData?.attributes?.backgroundColor }">
    <div>
        <div class="casino-game-tile-wrapper casino-lobby-width-gametile">
            <h2
                class="game-tile-heading casino-lobby-header"
                [ngClass]="{
                    'casino-uk-header': isUkHeading(),
                    'epcot-heading': enableEpcotSubNavigation(),
                    'coinarcade-game-title-heading': arcadeLobbyGameConfig() === currentLobbyType() && ShowArcadeCoinExpiry(),
                }"
                [ngStyle]="{ 'color': subCategoryTextColor(), 'font-family': lobbyTileFontFamily() }">
                @if (!isUkHeading()) {
                    <span class="category-title" [ngStyle]="{ 'font-size': subCategoryTitleFontSize() }">
                        {{ subCategoryInfo()?.categoryname }}

                        @if (showJackpotMoreInfo()) {
                            <p class="non-uk-jacpot-moreinfo theme-info" (click)="onOpenDialog($event)"></p>
                        }

                        @if (isSignPosting()) {
                            <cc-sign-posting [category]="subCategoryInfo()"> </cc-sign-posting>
                        }
                    </span>
                }

                @if (isUkHeading()) {
                    <cc-categoryicon-subtitle
                        [lobbyType]="currentLobbyType()"
                        [subCategory]="subCategoryInfo()"
                        [recentAndGyml]="'NotRecentAndGyml'"
                        [alignIconRight]="alignIconRight()" />
                }
            </h2>
        </div>
    </div>
</div>
